var _circle, _path, _path2, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6344 32C47.5188 29.4978 48 26.8051 48 24C48 21.1949 47.5188 18.5022 46.6344 16H1.36565C0.481232 18.5022 0 21.1949 0 24C0 26.8051 0.481232 29.4978 1.36565 32H46.6344Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6344 32C43.3397 41.3215 34.4498 48 24.0001 48C13.5503 48 4.66042 41.3215 1.36572 32H46.6344Z",
    fill: "#E62048"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgRu;